import Phaser from 'phaser';

import { shouldUseCanvasRenderer } from '@/shared/utils/browser';
import { getDevicePixelRatio } from '@/shared/utils/phaserCanvasSize';

import type LetterPartyScene from './scenes/LetterPartyScene';

export function createGameConfig(parent: HTMLElement, scene: LetterPartyScene): Phaser.Types.Core.GameConfig {
	const pixelRatio = getDevicePixelRatio();

	return {
		type: shouldUseCanvasRenderer() ? Phaser.CANVAS : Phaser.AUTO,
		parent,
		width: Math.max(1, Math.round((parent.clientWidth || 1) * pixelRatio)),
		height: Math.max(1, Math.round((parent.clientHeight || 1) * pixelRatio)),
		transparent: true,
		scene,
		scale: {
			mode: Phaser.Scale.NONE,
		},
		audio: {
			disableWebAudio: false,
		},
		antialias: true,
		roundPixels: true,
	};
}
